"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeHandlers;

var _midiMessageHandler = _interopRequireDefault(require("./midiMessageHandler"));

var _stateChangeHandler = _interopRequireDefault(require("./stateChangeHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function removeHandlers(device) {
  // midiAccess state change
  device._midi.removeEventListener('statechange', event => (0, _stateChangeHandler.default)(event, device), false);

  if (!device.isConnected()) return; // midi message handlers

  device.input.removeEventListener('midimessage', event => (0, _midiMessageHandler.default)(event, device), false);
}